import { Purchases, PurchasesOfferings, PurchasesPackage } from '@revenuecat/purchases-capacitor';
import { featureFlags } from '../config/envConfig';
import loggerService from './LoggerService';

export class IapService {
  private isInitialized = false;

  async initialize() {
    if (!featureFlags.iap) return; // Currently only forcing Apple IAP for iOS
    if (this.isInitialized) return;

    try {
      const apiKey = process.env.REACT_APP_REVENUECAT_IOS_KEY;
      if (!apiKey) {
        loggerService.error('REACT_APP_REVENUECAT_IOS_KEY is not defined');
        return;
      }
      await Purchases.configure({ apiKey });
      this.isInitialized = true;
    } catch (e) {
      loggerService.error(e);
    }
  }

  async getOfferings(): Promise<PurchasesOfferings | null> {
    if (!featureFlags.iap) return null;
    if (!this.isInitialized) await this.initialize();
    
    try {
      return await Purchases.getOfferings();
    } catch (e) {
      loggerService.error(e);
      return null;
    }
  }

  async purchasePackage(pkg: PurchasesPackage) {
    if (!featureFlags.iap) throw new Error('IAP is not enabled');
    try {
      const { customerInfo } = await Purchases.purchasePackage({ aPackage: pkg });
      return customerInfo;
    } catch (e: any) {
      if (!e.userCancelled) {
        loggerService.error(e);
      }
      throw e;
    }
  }

  async logIn(appUserId: string) {
    if (!featureFlags.iap) return;
    if (!this.isInitialized) await this.initialize();
    try {
      await Purchases.logIn({ appUserID: appUserId });
    } catch (e) {
      loggerService.error(e);
    }
  }

  async logOut() {
    if (!featureFlags.iap) return;
    if (!this.isInitialized) await this.initialize();
    try {
      await Purchases.logOut();
    } catch (e: any) {
      if (!e?.message?.includes('anonymous')) {
        loggerService.error(e);
      }
    }
  }
}

const iapService = new IapService();
export default iapService;
